import congressMenu from '@/navigation/congressMenu'

export default function (congressID) {
  return [...congressMenu(congressID)]
}
